import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Box, Toolbar, IconButton, Typography, Container, Button, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import colors from '../theme/colors';

const pages = [
    { label: 'Strona główna', path: '/' },
    { label: 'Usługi', path: '/services' },
    { label: 'Cennik', path: '/pricing' },
    // { label: 'Salon', path: '/salon' },
    { label: 'Kontakt', path: '/contact' },
];

function NavigationBar() {
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <AppBar position="static" sx={{ backgroundColor: "white", color: colors.text }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ position: 'relative' }}>
                    <Box display="flex" flexDirection="column" alignItems="center" sx={{ my: 1 }}>
                        <Typography
                            variant="h4"
                            noWrap
                            sx={{
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: "'Arizonia', cursive",
                                fontWeight: 400,
                                letterSpacing: '.1rem',
                                color: 'inherit',
                                textDecoration: 'none',
                                cursor: 'pointer',
                            }}
                            onClick={() => navigate('/')}
                        >
                            Lawendowy dotyk
                        </Typography>
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 400,
                                letterSpacing: '.1rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            dla zdrowia i ciała
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: { xs: 'none', md: 'flex' },
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            gap: 2,
                        }}
                    >
                        {pages.map((page) => (
                            <Button
                                key={page.label}
                                onClick={() => navigate(page.path)}
                                sx={{
                                    my: 1,
                                    display: 'block',
                                    color: location.pathname === page.path ? colors.lightPink : colors.text,
                                    fontSize: location.pathname === page.path ? '1.2rem' : '1rem',
                                    fontWeight: location.pathname === page.path ? 'bold' : 500,
                                }}
                            >
                                {page.label}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', position: 'relative', width: '100%' }}>
                        <IconButton
                            size="large"
                            aria-label="menu"
                            onClick={() => setOpenDrawer(true)}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>

                        <Typography
                            variant="h5"
                            noWrap
                            sx={{
                                position: 'absolute',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontFamily: "'Arizonia', cursive",
                                fontWeight: 400,
                                letterSpacing: '.1rem',
                                color: 'inherit',
                                textDecoration: 'none',
                                cursor: 'pointer',
                            }}
                            onClick={() => navigate('/')}
                        >
                            Lawendowy dotyk
                        </Typography>

                        <Drawer
                            anchor="top"
                            open={openDrawer}
                            onClose={() => setOpenDrawer(false)}
                            PaperProps={{ sx: { width: '100%', mt: 7 } }}
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 2 }}>
                                {pages.map((page) => (
                                    <Button
                                        key={page.label}
                                        onClick={() => {
                                            navigate(page.path);
                                            setOpenDrawer(false);
                                        }}
                                        sx={{
                                            width: '100%',
                                            py: 3,
                                            display: 'block',
                                            color: location.pathname === page.path ? colors.lightPink : colors.text,
                                        }}
                                    >
                                        {page.label}
                                    </Button>
                                ))}
                            </Box>
                        </Drawer>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default NavigationBar;
